module.exports = __webpack_public_path__ + "media/images/lb/128-a435f470569279936417181bf473cff1.svg";